export default __webpack_public_path__ + "static/media/Asset_47.8000b763.png";